import styled from 'styled-components';
const Divider = styled.hr `
    border: none;
    border-bottom: solid 1px ${(props) => props.theme.colors.border};
`;
export default Divider;
//# sourceMappingURL=index.js.map